import { useState } from 'react'
import { Space, Table, List, Typography, Alert } from 'antd'
import { camelCaseToWords } from '../displayFormatters'
import { renderContent } from './previewModel'

const { Text } = Typography

export default function NoMatch({ rowKey, attributes, dataSource, selectedMatches = [], updateSelectedMatches, duplicates }) {
  const initialSelectedRowKeys = selectedMatches.map(selectedMatch => selectedMatch[rowKey])
  const [selectedRowKeys, setSelectedRowKeys] = useState(initialSelectedRowKeys);

  if (!rowKey || rowKey === 'both') {
    rowKey = 'name'
  }

  let columns = []
  if (attributes && Array.isArray(attributes)) {
    columns = attributes.map(attribute => {
      return {
        title: camelCaseToWords(attribute),
        dataIndex: attribute,
        key: attribute,
        render: renderContent(attribute, false),
      }
    })
  }

  const onSelectionChange = selectedRowKeys => {
    if (updateSelectedMatches) {
      const selectedData = dataSource.filter(data => {
        return data[rowKey] && selectedRowKeys.includes(data[rowKey])
      })
      updateSelectedMatches(selectedData)
    }

    setSelectedRowKeys(selectedRowKeys)
  }


  if (duplicates.length > 0) {
    return <Space direction="vertical">
      <Alert
        type="error"
        showIcon
        description={<>We found a problem with your file that we can't resolve automatically. The following items appear more than once in your file with differing values.</>}
      />
      <List
        dataSource={duplicates}
        pagination={{ pageSize: 10 }}
        renderItem={(item) => {
          return <List.Item>
            <Space>
              {item.name && <Text>Name: <code>{item.name}</code></Text>}
              {item.sku && <Text>SKU: <code>{item.sku}</code></Text>}
            </Space>
          </List.Item>
        }} />
    </Space>
  }

  return <>
    <Space direction="vertical" style={{ width: '100%' }}>
      These items did not have a match in the item catalog. Please select the ones you would like to include in the import.
      <Table
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys,
          onChange: onSelectionChange,
        }}
        rowKey={rowKey}
        dataSource={dataSource}
        columns={columns}
        size="small"
      />
    </Space>
  </>
}
